import React from 'react';

type BundleSkeletonProps = {
  loading: boolean;
};

const BundleSkeleton = ({ loading }: BundleSkeletonProps): JSX.Element => {
  return (
    <div className={`skeleton ${!!loading && 'loading'} bundle-skeleton`}>
      <div className="products">
        <div className="product">
          <div className="image" />
          <div className="title" />
        </div>
        <div className="divider"></div>
        <div className="product">
          <div className="image" />
          <div className="title" />
        </div>
      </div>
      <div className="price" />
      <div className="addtocart" />
    </div>
  );
};

export default BundleSkeleton;
